import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { spaceAuthorityOrderSchema } from "./authority-order.js";
import { spaceDispatchPolicySchema } from "./dispatch-policy.js";
import { spaceAllowedActionsSchema, spacePublicationModeSchema } from "./publication-policy.js";
import { resultArchivePolicySchema } from "./result-archive-policy.js";
import { spaceNoteSchema } from "./space-note.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/space-contract.ts
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const spaceBriefModeSchema = z$1.enum(["default", "none"]);
const spaceContractFieldsSchema = z$1.strictObject({
	dispatchPolicy: spaceDispatchPolicySchema,
	publicationMode: spacePublicationModeSchema,
	allowedActions: spaceAllowedActionsSchema,
	resultArchivePolicy: resultArchivePolicySchema,
	spaceNote: spaceNoteSchema.optional(),
	authorityOrder: spaceAuthorityOrderSchema,
	entryBrief: spaceBriefModeSchema,
	dispatchBrief: spaceBriefModeSchema
});
const spaceContractSchema = z$1.strictObject({
	version: z$1.number().int().finite().positive(),
	updatedAt: isoDateTimeSchema,
	updatedBy: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	dispatchPolicy: spaceDispatchPolicySchema,
	publicationMode: spacePublicationModeSchema,
	allowedActions: spaceAllowedActionsSchema,
	resultArchivePolicy: resultArchivePolicySchema,
	spaceNote: spaceNoteSchema.optional(),
	authorityOrder: spaceAuthorityOrderSchema,
	entryBrief: spaceBriefModeSchema,
	dispatchBrief: spaceBriefModeSchema
});
//#endregion
export { spaceBriefModeSchema, spaceContractFieldsSchema, spaceContractSchema };

//# sourceMappingURL=space-contract.js.map